export default {
  POWERED_BY_MERINIO: `Propulsé par Merinio`,
  START_AT_THIS_LOCATION: `Lancer le terminal de poinçonnage à cet emplacement :`,
  LAUNCH_PUNCH_TERMINAL: `Lancer le terminal de poinçonnage`,
  GO_TO: `Aller au terminal`,
  START_PUNCH_SESSION: `Terminal de poinçonnage`,
  INVALID_PUNCH_TERMINAL_TOKEN: 'Session invalide, veuillez contacter votre responsable / Invalid session, please contact your manager',
  AUTH_PUNCH: 'Poinçonner',
  AUTH_EMPLOYEE_NUMBER: `Numéro d'employé`,
  AUTH_EMPLOYEE_ID: `Identifiant employé`,
  AUTH_CANNOT_FIND_EMPLOYEE_BY_EMPLOYEENUMBER: "Aucun employé ne possède ce numéro d'employé / Cannot find an employee with this employee number",
  AUTH_CANNOT_FIND_EMPLOYEE_BY_EMPLOYEEID: 'Aucun employé ne possède cet identifiant employé / Cannot find an employee with this employee ID',
  INACTIVE_ARCHIVED_USER_CANT_LOGIN:
    "Les utilisateurs archivés, inactifs, et résiliés ne peuvent pas se connecter / Inactive, archived, or terminated users can't login",
  AUTH_NO_EMPLOYEE_NUMBER: "Vous devez spécifier un numéro d'employé / You must enter an employee number",
  UNSPECIFIED_ERROR_PLEASE_CHECK_CONNECTION:
    "An unknown error has occurred, please check your connection / Une erreur inconnue s'est produite, veuillez vérifier votre connexion",
  notification: {
    ARRIVAL_SAVED: `Heure d'arrivée enregistrée`,
    ARRIVAL_SAVED_DESC: `{{userName}}, votre <1>heure d'entrée</1> a été enregistrée à <2>{{time}}</2>.`,
    ARRIVAL_INFO: `Vous êtes arrivé <0>{{delay}}</0> {{type}} !`,
    DEPARTURE_SAVED: `Heure de sortie enregistrée`,
    DEPARTURE_ALREADY_SAVED: `Heure de sortie déjà enregistrée`,
    DEPARTURE_SAVED_DESC: `{{userName}}, votre <1>heure de sortie</1> a été enregistrée à <2>{{time}}</2>. Vous avez travaillé <3>{{workedHours}}</3>.`,
    DEPARTURE_INFO: `Vous êtes parti <0>{{delay}}</0> {{type}} !`,
    PUNCH_CREATED: `Carte de temps créée`,
    NO_ARRIVAL_OR_DEPARTURE_SAVED: `Une carte de temps a été créée, par contre, aucune heure d'entrée ou de sortie n'a été enregistrée.`,
    LOCATION_WARNING: `Votre emplacement ne correspond pas à l'emplacement du quart`,
    NO_LOCATION_ACCESS: `Merinio n'a pas accès à votre position.`,
    TRANSFER_SAVED: `Transfert sauvegardé`,
    TRANSFER_SAVED_DESC: `{{userName}}, votre <1>transfert</1> a été enregistré à <2>{{time}}</2>.`,
    BREAK_START_SAVED: `Début de pause enregistré`,
    BREAK_START_SAVED_DESC: `{{userName}}, votre <1>début de pause</1> a été enregistré à <2>{{time}}</2>.`,
    BREAK_END_SAVED: `Fin de pause enregistrée`,
    BREAK_END_SAVED_DESC: `{{userName}}, votre <1>fin de pause</1> a été enregistrée à <2>{{time}}</2>.`
  },
  DETECTED_SOME_PUNCH_ISSUES: {
    TITLE: `Nous avons détecté des problèmes`,
    SUMMARY: '',
    DESC: `Vous n'avez pas enregistré l'heure de sortie de certains quarts de travail et vous essayez peut-être d'enregistrer votre entrée.`,
    PUNCHED_IN_AT: `Poinçon d'entrée à <0>{{ time }}</0>`
  },
  YOU_HAVENT_PUNCH_OUT_THESE_SHIFT: `Ces quarts de travail n'ont pas d'heure de sortie :`,
  PUNCH_IN: "Enregistrer l'heure d'entrée",
  PUNCH_OUT: `Enregistrer l'heure de sortie`,
  PUNCH_SEE_INFOS: `Voir les informations du quart de travail`,
  LATE: `en retard`,
  EARLY: `en avance`,
  LOGOUT_RETURN_TO_TERMINAL: `Annuler`,
  NO_SHIFT_TO_PUNCH: `Il semblerait que vous n'ayez pas de quart de travail aujourd'hui. En cas d'erreur, communiquez avec votre gestionnaire.`,
  PUNCH_IN_ANYWAY: "Quand même enregistrer l'<0>heure d'entrée</0>",
  PUNCH_OUT_ANYWAY: `Quand même enregistrer l'<0>heure de sortie</0>`,
  SHIFTS_ALREADY_PUNCHED: `Quarts déjà poinçonnés`,
  ALREADY_PUNCHED_IN_OUT: "Tu as déjà enregistré ton heure d'entrée et de sortie",
  SELECT_SHIFT_GREETING: `Bonjour <0>{{userName}}</0>, choisis ton quart de travail :`,
  DASHBOARD_GREETING: `Bonjour <0>{{userName}}</0>, voici les informations sur ton quart de travail.`,
  DASHBOARD_DESCRIPTION: `Permet d'enregistrer ci-dessous ton heure d'entrée, ton heure de sortie à la fin de ton quart de travail et tes pauses.`,
  DASHBOARD_DONE_DESCRIPTION: `Ton temps de travail à été enregistré. Passe une excellente journée! 🎉`,
  DASHBOARD_WORK_HOURS: 'Temps de travail',
  DASHBOARD_START_TIME: 'Heure de début',
  DASHBOARD_END_TIME: 'Heure de fin',
  DASHBOARD_ARRIVED_AT: 'Arrivé à',
  DASHBOARD_LEFT_AT: 'Parti à',
  DASHBOARD_TAKE_BREAK: 'Prendre ta pause',
  DASHBOARD_UNPLANNED_BREAK: 'Pause non planifiée',
  DASHBOARD_UNPLANNED_BREAK_DESCRIPTION: 'Prendre une pause non planifiée.',
  DASHBOARD_BREAK_BREAK_TAKEN: 'Tu as pris cette pause',
  DASHBOARD_NO_BREAKS: 'Aucune pause',
  DASHBOARD_YOU_PUNCHED_IN: "Tu as enregistré ton heure d'entrée",
  DASHBOARD_YOU_PUNCHED_OUT: 'Tu as enregistré ton heure de sortie',
  DASHBOARD_HAVE_A_NICE_DAY: 'Passe une excellente journée!',
  DASHBOARD_DID_NOT_TAKE_BREAK: "Tu n'as pas pris cette pause",
  DASHBOARD_SHIFT_INFO: 'Quart de travail',
  DASHBOARD_BACK_TO_PUNCH: 'Revenir au terminal de poinçonnage',
  NO_ASSOCIATED_SHIFT: 'Pas de quart de travail associé',
  POSITION: `Position`,
  PROJECT: `Projet`,
  COMMENT: `Commentaire`,
  TRANSFER_TIME: `Heure du transfert`,
  TRANSFER_TO_POSITION: 'Transférer à cette position',
  TRANSFER_TO_PROJECT: 'Transférer à ce projet',
  START_TRANSFER: 'Débuter le transfert',
  TRANSFER: 'transfert',
  SELECT_POSITION: 'Choisis la position',
  TRANSFERED_TO: 'a transféré à',
  TRANSFERS: 'Transferts',
  BREAKS: `Pauses`,
  PAID: `Payée`,
  MISSING_ATTRIBUTES: `Compétences manquantes`,
  TRANSFER_POSITION: 'Transférer à cette position',
  TRANSFER_LOCATION: 'Emplacement du transfert',
  DASHBOARD_TRANSFER_UNAVAILABLE: "Impossible d'enregistrer un transfert en ce moment",
  DASHBOARD_TRANSFER_UNAVAILABLE_DESCRIPTION:
    "Vous ne pouvez pas transférer tant que vous n'avez pas poinçonné votre heure d'entrée. Vous ne pouvez pas non plus transférer après avoir poinçonné votre heure de sortie.",
  DURATION: `Durée`,
  DASHBOARD_BREAK_UNAVAILABLE: 'Impossible de prendre une pause en ce moment',
  DASHBOARD_BREAK_UNAVAILABLE_DESCRIPTION:
    "Vous ne pouvez pas prendre de pause tant que vous n'avez pas poinçonné votre entrée. Vous ne pouvez pas non plus prendre de pause après avoir poinçonné votre sortie.",
  BREAKINFO_ON_BREAK: 'Vous êtes en pause',
  BREAKINFO_BREAK_DECLARATION: 'Ta pause {{name}} est en cours.',
  BREAKINFO_RETURN_EXPECTATION: 'Ta pause se termine à',
  BREAKINFO_BREAK_ENDED: 'Ta pause est terminée',
  BREAKINFO_CUSTOM_BREAK_INFO: `Tu as pris une pause non planifiée. Appuie sur le bouton ci-dessous lorsqu'elle sera terminée.`,
  BREAKINFO_RESUME_WORK_INSTRUCTIONS: 'Pour reprendre ton quart de travail, appuie sur le bouton ci-dessous',
  BREAKINFO_RESUME_WORK: 'Terminer la pause',
  BREAK_NOT_FOUND: 'Impossible de trouver la pause',
  INVALID_BREAK: 'Pause invalide',
  CUSTOMBREAK_TITLE: 'Prendre la pause',
  CUSTOMBREAK_REASON_LABEL: 'Pourquoi prends-tu une pause?',
  CUSTOMBREAK_START_BREAK: 'Commencer la pause',
  LOADING_SHIFTS: `Chargement des quarts de travail`,
  END_UNAVAILABLE: `Heure de fin non-disponible`,
  CLOSE_PUNCH_TERMINAL: {
    TITLE: `Fermer le terminal de poinçon`,
    SUMMARY: `Suspendre l'accès au terminal de poinçonnage, pour tous les utilisateurs et revenir à l'écran de connexion principal.`,
    BUTTON: `Fermer le terminal`,
    CANCEL: `Annuler`,
    CONFIRM: `Confirmer`
  },
  punchLocation: {
    LOCATION_SELECTION: {
      TITLE: `Emplacement du terminal de poinçon`,
      SUMMARY: `L'emplacement sélectionné va être ajouté aux poinçons des employés afin de savoir où ils ont effectué leurs actions.`
    },
    LOCATIONID: {
      LABEL: `Emplacement`,
      DESCRIPTION: `Sélectionner l'emplacement du terminal.`
    }
  },
  NO_LOCATIONS: `Aucun emplacement disponible. Vous pouvez quand même lancer le terminal de poinçon.`,
  REQUIRED_FIELD: `Ce champs est requis.`,
  END_DATE_REQUIRED_IF_END_TIME: `La date de fin est requise si la carte a une heure de fin`,
  CANNOT_CREATE_PUNCHCARD_IN_FUTURE: `Vous ne pouvez pas créer une carte de temps dans le futur.`,
  PUNCH_QUESTIONNAIRE_MODAL: {
    TITLE: `Questionnaire de poinçon`,
    SUMMARY: ``,
    NOT_ALLOWED_TO_PUNCH: `En raison de vos réponses au questionnaire, vous n'avez pas le droit de poinçonner, veuillez contacter votre gestionnaire.`,
    PLEASE_PUNCH_IN: `Merci, vous pouvez maintenant continuer à poinçonner.`,
    EXPLANATION: {
      LABEL: `Explication`,
      PLACEHOLDER: `Indiquez la raison du changement de vos réponses.`,
      DESCRIPTION: ``
    },
    EXPLANATION_WARNING: `Vous avez récemment répondu au questionnaire de manière à ne pas pouvoir poinçonner.`,
    ANSWER_ALL_QUESTIONS: `Veuillez répondre à toutes les questions.`
  },
  GREATER_THAN_ZERO: `Doit être supérieur à 0`
}
